//// Application Packages
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

//// Application Slices
import {
    updateSubFormData,
    updateFormData,
    updateSubFormValidity,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Carbon Components
import { Select, SelectItem } from '@carbon/react'

//// Application Components

//// Carbon Icons

//// Static Constants

//////// Component
const StateSelectorComponent = ({
    instance,
    digital_name,
    digital_sub_name,
    value_key,
    country,
}) => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const formsData = useSelector(selectForms)

    //// Slice Data

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        try {
            if (digital_name && digital_sub_name) {
                dispatch(
                    updateSubFormValidity({
                        digital_name: digital_name,
                        digital_sub_name: digital_sub_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            } else {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        } catch (error) {
            console.warn('Revalidation Error:', error)
            return null
        }
    }

    // Handle Data Of All Fields
    const handleData = (e) => {
        if (digital_name && digital_sub_name) {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateSubFormData({
                        digital_name: digital_name,
                        digital_sub_name: digital_sub_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateSubFormData({
                        digital_name: digital_name,
                        digital_sub_name: digital_sub_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            }
        } else {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            }
        }
        //// Start Watson Assistant Journey

        if (digital_name === 'contact-information') {
            if (e?.target?.name === 'st_cdeMA') {
                if (e?.target?.value !== 'FL') {
                    if (formsData?.['get-started']?.values?.GetStar === 'Y') {
                        instance.tours.startTour(
                            'Registered Nursing Endorsement Contact Info Not Florida Tour'
                        )
                    }
                } else if (e?.target?.value === 'FL') {
                    if (formsData?.['get-started']?.values?.GetStar === 'Y') {
                        instance.tours.endTour()
                    }
                }
            }
        }

        //// End Watson Assistant Journey
    }

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (
        digital_name &&
        digital_sub_name &&
        value_key &&
        (country === '' || country === undefined || country === 'US')
    ) {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            value_key
                        ]
                    }
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            value_key
                        ]
                    }
                    helper=""
                    labelText="State:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            value_key
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Alabama" value="AL" />
                    <SelectItem text="Alaska" value="AK" />
                    <SelectItem text="American Samoa" value="AS" />
                    <SelectItem text="Arizona" value="AZ" />
                    <SelectItem text="Arkansas" value="AR" />
                    <SelectItem text="California" value="CA" />
                    <SelectItem text="Colorado" value="CO" />
                    <SelectItem text="Connecticut" value="CT" />
                    <SelectItem text="Delaware" value="DE" />
                    <SelectItem text="District of Columbia" value="DC" />
                    <SelectItem text="F. S. of Micronesia" value="FM" />
                    <SelectItem text="Florida" value="FL" />
                    <SelectItem text="Georgia" value="GA" />
                    <SelectItem text="Guam" value="GU" />
                    <SelectItem text="Hawaii" value="HI" />
                    <SelectItem text="Idaho" value="ID" />
                    <SelectItem text="Illinois" value="IL" />
                    <SelectItem text="Indiana" value="IN" />
                    <SelectItem text="Iowa" value="IA" />
                    <SelectItem text="Kansas" value="KS" />
                    <SelectItem text="Kentucky" value="KY" />
                    <SelectItem text="Louisiana" value="LA" />
                    <SelectItem text="Maine" value="ME" />
                    <SelectItem text="Marshall Islands" value="MH" />
                    <SelectItem text="Maryland" value="MD" />
                    <SelectItem text="Massachusetts" value="MA" />
                    <SelectItem text="Michigan" value="MI" />
                    <SelectItem text="Military A" value="AA" />
                    <SelectItem text="Military E" value="AE" />
                    <SelectItem text="Military P" value="AP" />
                    <SelectItem text="Minnesota" value="MN" />
                    <SelectItem text="Mississippi" value="MS" />
                    <SelectItem text="Missouri" value="MO" />
                    <SelectItem text="Montana" value="MT" />
                    <SelectItem text="N. Carolina" value="NC" />
                    <SelectItem text="N. Dakota" value="ND" />
                    <SelectItem text="N. Marianas" value="MP" />
                    <SelectItem text="Nebraska" value="NE" />
                    <SelectItem text="Nevada" value="NV" />
                    <SelectItem text="New Hampshire" value="NH" />
                    <SelectItem text="New Jersey" value="NJ" />
                    <SelectItem text="New Mexico" value="NM" />
                    <SelectItem text="New York" value="NY" />
                    <SelectItem text="Ohio" value="OH" />
                    <SelectItem text="Oklahoma" value="OK" />
                    <SelectItem text="Oregon" value="OR" />
                    <SelectItem text="Palau" value="PW" />
                    <SelectItem text="Pennsylvania" value="PA" />
                    <SelectItem text="Puerto Rico" value="PR" />
                    <SelectItem text="Rhode Island" value="RI" />
                    <SelectItem text="S. Carolina" value="SC" />
                    <SelectItem text="S. Dakota" value="SD" />
                    <SelectItem text="Tennessee" value="TN" />
                    <SelectItem text="Texas" value="TX" />
                    <SelectItem text="Utah" value="UT" />
                    <SelectItem text="Vermont" value="VT" />
                    <SelectItem text="Virgin Islands" value="VI" />
                    <SelectItem text="Virginia" value="VA" />
                    <SelectItem text="Washington" value="WA" />
                    <SelectItem text="West Virginia" value="WV" />
                    <SelectItem text="Wisconsin" value="WI" />
                    <SelectItem text="Wyoming" value="WY" />
                </Select>
            </>
        )
    } else if (
        digital_name &&
        value_key &&
        (country === '' || country === undefined || country === 'US')
    ) {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.[value_key]
                    }
                    value={formsData?.[digital_name]?.values?.[value_key]}
                    helper=""
                    labelText="State:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.[value_key]}
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="Alabama" value="AL" />
                    <SelectItem text="Alaska" value="AK" />
                    <SelectItem text="American Samoa" value="AS" />
                    <SelectItem text="Arizona" value="AZ" />
                    <SelectItem text="Arkansas" value="AR" />
                    <SelectItem text="California" value="CA" />
                    <SelectItem text="Colorado" value="CO" />
                    <SelectItem text="Connecticut" value="CT" />
                    <SelectItem text="Delaware" value="DE" />
                    <SelectItem text="District of Columbia" value="DC" />
                    <SelectItem text="F. S. of Micronesia" value="FM" />
                    <SelectItem text="Florida" value="FL" />
                    <SelectItem text="Georgia" value="GA" />
                    <SelectItem text="Guam" value="GU" />
                    <SelectItem text="Hawaii" value="HI" />
                    <SelectItem text="Idaho" value="ID" />
                    <SelectItem text="Illinois" value="IL" />
                    <SelectItem text="Indiana" value="IN" />
                    <SelectItem text="Iowa" value="IA" />
                    <SelectItem text="Kansas" value="KS" />
                    <SelectItem text="Kentucky" value="KY" />
                    <SelectItem text="Louisiana" value="LA" />
                    <SelectItem text="Maine" value="ME" />
                    <SelectItem text="Marshall Islands" value="MH" />
                    <SelectItem text="Maryland" value="MD" />
                    <SelectItem text="Massachusetts" value="MA" />
                    <SelectItem text="Michigan" value="MI" />
                    <SelectItem text="Military A" value="AA" />
                    <SelectItem text="Military E" value="AE" />
                    <SelectItem text="Military P" value="AP" />
                    <SelectItem text="Minnesota" value="MN" />
                    <SelectItem text="Mississippi" value="MS" />
                    <SelectItem text="Missouri" value="MO" />
                    <SelectItem text="Montana" value="MT" />
                    <SelectItem text="N. Carolina" value="NC" />
                    <SelectItem text="N. Dakota" value="ND" />
                    <SelectItem text="N. Marianas" value="MP" />
                    <SelectItem text="Nebraska" value="NE" />
                    <SelectItem text="Nevada" value="NV" />
                    <SelectItem text="New Hampshire" value="NH" />
                    <SelectItem text="New Jersey" value="NJ" />
                    <SelectItem text="New Mexico" value="NM" />
                    <SelectItem text="New York" value="NY" />
                    <SelectItem text="Ohio" value="OH" />
                    <SelectItem text="Oklahoma" value="OK" />
                    <SelectItem text="Oregon" value="OR" />
                    <SelectItem text="Palau" value="PW" />
                    <SelectItem text="Pennsylvania" value="PA" />
                    <SelectItem text="Puerto Rico" value="PR" />
                    <SelectItem text="Rhode Island" value="RI" />
                    <SelectItem text="S. Carolina" value="SC" />
                    <SelectItem text="S. Dakota" value="SD" />
                    <SelectItem text="Tennessee" value="TN" />
                    <SelectItem text="Texas" value="TX" />
                    <SelectItem text="Utah" value="UT" />
                    <SelectItem text="Vermont" value="VT" />
                    <SelectItem text="Virgin Islands" value="VI" />
                    <SelectItem text="Virginia" value="VA" />
                    <SelectItem text="Washington" value="WA" />
                    <SelectItem text="West Virginia" value="WV" />
                    <SelectItem text="Wisconsin" value="WI" />
                    <SelectItem text="Wyoming" value="WY" />
                </Select>
            </>
        )
    } else if (
        digital_name &&
        digital_sub_name &&
        value_key &&
        country !== 'US'
    ) {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            value_key
                        ]
                    }
                    value={
                        formsData?.[digital_name]?.[digital_sub_name]?.values?.[
                            value_key
                        ]
                    }
                    helper=""
                    labelText="State:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            value_key
                        ]
                    }
                    invalidText={
                        formsData?.[digital_name]?.[digital_sub_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="FOREIGN" value="FRG" />
                </Select>
            </>
        )
    } else {
        return (
            <>
                <Select
                    className="required"
                    defaultValue={
                        formsData?.[digital_name]?.values?.[value_key]
                    }
                    value={formsData?.[digital_name]?.values?.[value_key]}
                    helper=""
                    labelText="State:"
                    id={value_key}
                    name={value_key}
                    onChange={handleData}
                    invalid={formsData?.[digital_name]?.errors?.[value_key]}
                    invalidText={
                        formsData?.[digital_name]?.errors?.[
                            value_key + 'ErrMsg'
                        ]
                    }
                >
                    <SelectItem text="Choose an option" value="" />
                    <SelectItem text="FOREIGN" value="FRG" />
                </Select>
            </>
        )
    }
}

export default StateSelectorComponent
